import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Layout
import MainLayout from "./components/layout/MainLayout";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PDVPage from "./pages/PDVPage";
import ProductsPage from "./pages/ProductsPage";
import StockPage from "./pages/StockPage";
import ReportsPage from "./pages/ReportsPage";
import UsersPage from "./pages/UsersPage";
import CashRegisterPage from "./pages/CashRegisterPage";
import FinancialPage from "./pages/FinancialPage";
import CombosPage from "./pages/CombosPage";
import CompositeProductsPage from "./pages/CompositeProductsPage";
import ExpensesPage from "./pages/ExpensesPage";
import ComandasPage from "./pages/ComandasPage";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* Public Routes - Redirect to login */}
                    <Route path="/" element={<Navigate to="/acesso" replace />} />
                    <Route path="/acesso" element={<LoginPage />} />
                    
                    {/* Protected Admin Routes */}
                    <Route path="/admin" element={<MainLayout />}>
                        <Route index element={<Navigate to="/admin/dashboard" replace />} />
                        <Route path="dashboard" element={<DashboardPage />} />
                        <Route path="pdv" element={<PDVPage />} />
                        <Route path="comandas" element={<ComandasPage />} />
                        <Route path="caixa" element={<CashRegisterPage />} />
                        <Route path="financeiro" element={<FinancialPage />} />
                        <Route path="despesas" element={<ExpensesPage />} />
                        <Route path="combos" element={<CombosPage />} />
                        <Route path="produtos-compostos" element={<CompositeProductsPage />} />
                        <Route path="produtos" element={<ProductsPage />} />
                        <Route path="estoque" element={<StockPage />} />
                        <Route path="relatorios" element={<ReportsPage />} />
                        <Route path="usuarios" element={<UsersPage />} />
                    </Route>

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/acesso" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" />
        </AuthProvider>
    );
}

export default App;
